fx.ns("models", class ProductPosterPage extends  models.CreationElement {

	constructor(data)
	{
		super(data);
	}
	
});
